export default __webpack_public_path__ + "static/Glow-73189adbc33f0f5bf510fe65c6798f35.png";